
import { app } from "@/config/firebase";
import { getFirestore } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import _ from 'lodash';

// Initialize Firebase
const auth = getAuth();
const db = getFirestore(app);

async function login(email, password) {
    try {
        let userCredential = await signInWithEmailAndPassword(auth, email, password);
        return userCredential.user;
    } catch (error) {
        throw error;
    }
}

async function logout() {
    try {
        signOut(auth);
        return true;
    } catch (error) {
        throw error;
    }
}

async function setUserSessionAttempts(attempt) {
    return null
}

export default {
    login,
    logout,
    setUserSessionAttempts
}